import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { toast } from "react-toastify";
import { useScreenSize } from "../../../hooks/useScreenSize";
import { Expeditor } from "../../../services";
import Loading from "../../shared/Loading/Loading";
import EmptyContent from "../../shared/emptyContent";
import style from "./invitationHistoryTable.module.scss";

const STATUS_LABEL_KEYS = {
  PendingActivation: "partnersPage.invitationHistory.statuses.pendingActivation",
  LinkExpired: "partnersPage.invitationHistory.statuses.linkExpired",
};

const STATUS_COLORS = {
  PendingActivation: "#6d94ff",
  LinkExpired: "#9E0812",
};

const formatDate = (date) => (date ? moment(date).format("DD.MM.YY, HH:mm") : "—");

const InvitationHistoryTable = () => {
  const { t } = useTranslation();
  const { isMobileView } = useScreenSize();
  const [links, setLinks] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [resendingId, setResendingId] = useState(null);

  const getLinks = () => {
    setLoading(true);
    Expeditor.getPartnerLinks()
      .then((response) => {
        setLinks(response.data);
      })
      .catch((err) => {
        console.log(err);
        setLinks([]);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getLinks();
  }, []);

  const handleResend = (link) => {
    if (!link.email) return;
    setResendingId(link.id);
    Expeditor.createPartner("by-email", { email: link.email.trim() })
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          toast.success(t("partnersPage.invitationHistory.resendSuccess"));
          getLinks();
        } else {
          toast.error(t("partnersPage.invitationHistory.resendError"));
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(t("partnersPage.invitationHistory.resendError"));
      })
      .finally(() => setResendingId(null));
  };

  if (isLoading) {
    return <Loading inBlock />;
  }

  if (!links.length) {
    return <EmptyContent />;
  }

  return (
    <div className={style.tableSection}>
      <div className={style.tableContainer}>
        <table className={style.historyTable}>
          <thead>
            <tr>
              <th>{t("partnersPage.invitationHistory.sentDate")}</th>
              <th>{t("partnersPage.table.email")}</th>
              <th>{t("partnersPage.table.status")}</th>
              <th>{t("partnersPage.invitationHistory.expirationDate")}</th>
              {!isMobileView && <th>{t("partnersPage.table.actions")}</th>}
            </tr>
          </thead>
          <tbody>
            {links.map((link) => (
              <tr key={link.id}>
                <td className={style.date}>{formatDate(link.createdAt)}</td>
                <td className={style.email}>{link.email || "—"}</td>
                <td>
                  <span
                    className={style.status}
                    style={{ color: STATUS_COLORS[link.status] || "#6d7885" }}
                  >
                    {STATUS_LABEL_KEYS[link.status] ? t(STATUS_LABEL_KEYS[link.status]) : link.status}
                  </span>
                </td>
                <td className={style.date}>{formatDate(link.expireDate)}</td>
                {!isMobileView && (
                  <td>
                    {link.status === "LinkExpired" && link.email && (
                      <button
                        className={style.actionButton}
                        disabled={resendingId === link.id}
                        onClick={() => handleResend(link)}
                      >
                        {resendingId === link.id
                          ? t("partnersPage.invitationHistory.sending")
                          : t("partnersPage.invitationHistory.resend")}
                      </button>
                    )}
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default InvitationHistoryTable;
